/* eslint-disable operator-linebreak */
/* eslint-disable arrow-body-style */
import React, { useState } from 'react';

import { TableColumn } from 'react-data-table-component';
import { CustomCheckBox } from 'pg-ui-library';
import SettingsIcn from 'src/assets/table_config_icn.svg';
import SaveIcn from 'src/assets/save.svg';
import { SettingsIcon, Settings, Container, CheckboxContainer, RelativeContainer, AbsoluteContainer } from './styles';

export const SettingsButton: React.FC<{
  columns: TableColumn<any>[];
  setColumns: Function;
}> = ({ columns, setColumns }) => {
  const [open, setIsOpen] = useState<boolean>(false);
  const [internalColumns, setInternalColumns] = useState<TableColumn<any>[]>(columns);

  const handleChange = (name: string) => {
    const updatedColumns = internalColumns.map(item => {
      if (item.name === name) {
        return { ...item, omit: !item.omit };
      }
      return item;
    });
    setInternalColumns(updatedColumns);
  };

  const handleOpenClose = () => {
    setIsOpen(!open);
    if (open) {
      setColumns(internalColumns);
    }
  };

  return (
    <Container>
      <Settings onClick={handleOpenClose}>
        <SettingsIcon src={open ? SaveIcn : SettingsIcn} />
      </Settings>

      {open && (
        <RelativeContainer>
          <AbsoluteContainer>
            <CheckboxContainer>
              {internalColumns.map((item, index) => {
                if (item.name && typeof item.name === 'string') {
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={index}>
                      <CustomCheckBox
                        label={item.name}
                        id={item.name}
                        name={item.name}
                        checked={!item.omit}
                        onChange={() => handleChange(item.name as string)}
                      />
                    </div>
                  );
                }
                return '';
              })}
            </CheckboxContainer>
          </AbsoluteContainer>
        </RelativeContainer>
      )}
    </Container>
  );
};
